/** @requirement S-040 AC #1 — `Toast` primitive (Sonner wrapper).
 *  Re-exports the `toast()` API from `sonner` with a themed
 *  `<Toaster />` that reads from chrome tokens. The app-level Toaster
 *  is mounted in `apps/web/src/main.tsx`; this file exposes a themed
 *  Toaster + the toast dispatch API so consumers get one import. */

import { Toaster as SonnerToaster, type ToasterProps, toast } from 'sonner';

export { toast };

export function Toaster(props: ToasterProps): React.ReactElement {
  return (
    <SonnerToaster
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'rounded-md border border-chrome-border-subtle bg-chrome-surface text-chrome-text-primary shadow-md',
          title: 'font-medium',
          description: 'text-chrome-text-secondary text-sm',
        },
      }}
      {...props}
    />
  );
}
